import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const MapIcon: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.6129 4.07033L10.4129 2.07049C10.2162 1.9765 9.9838 1.9765 9.7864 2.07049L5.9 3.92167L2.0129 2.07049C1.7959 1.96784 1.5376 1.97784 1.3318 2.09982C1.126 2.22181 1 2.4358 1 2.66711V11.3331C1 11.5857 1.1498 11.8163 1.3871 11.9297L5.5871 13.9295C5.7838 14.0235 6.0162 14.0235 6.2136 13.9295L10.1 12.0783L13.9871 13.9288C14.0858 13.9762 14.1929 13.9995 14.3 13.9995C14.4281 13.9995 14.5555 13.9662 14.6675 13.9002C14.874 13.7782 15 13.5642 15 13.3329V4.66694C15 4.4143 14.8502 4.18365 14.6129 4.07033ZM6.6 5.07891L9.4 3.74569V10.9211L6.6 12.2543V5.07891ZM2.4 3.74569L5.2 5.07891V12.2543L2.4 10.9211V3.74569ZM13.6 12.2543L10.8 10.9211V3.74569L13.6 5.07891V12.2543Z'
      fill={color} />
  </svg>
)

export default MapIcon
